import { render, staticRenderFns } from "./StokPromo.vue?vue&type=template&id=d1e7b566&"
import script from "./StokPromo.vue?vue&type=script&lang=js&"
export * from "./StokPromo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports